<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-xl-10 col-xxl-9">
                <br />

                <!-- Empty Message -->
                <div v-show="agents.length === 0 && !loading" class=" mt-4">
                    <br />
                    <br />
                    <h1 class="h5 mb-3 font-weight-bolder">
                        <span class="icon icon-glyphicons-basic-user-chat mr-2"></span>
                        <span>Manage Chat Agents</span>
                    </h1>
                    <p class="text-secondary mb-3">No chat agents have been created for your organization yet.</p>
                </div>

                <!-- Non-Empty Display -->
                <div v-show="agents.length > 0 && !loading">
                    <div class="d-flex mb-3">
                        <div class="flex-grow-1 align-self-center">
                            <br />
                            <h1 class="h5 font-weight-bolder mb-3">
                                <span class="icon icon-glyphicons-basic-user-chat mr-2"></span>
                                <span>Chat Agents</span>
                            </h1>
                            <p class="text-secondary mb-2">
                                To request a new chat agent for your organization, please
                                <a
                                    target="_blank"
                                    href="mailto:support@affinitylearning.ca?subject=Chat Agent Creation Request"
                                    >contact our team</a
                                >.
                            </p>
                        </div>
                    </div>
                </div>

                <div v-show="!loading" class="alert alert-primary border-0 mb-4">
                    <span class="icon icon-glyphicons-basic-circle-alert mr-2 align-middle"></span>
                    <span class="align-middle">Note: This feature has been replaced by the new <strong>Custom GPT</strong> content-type.</span>
                </div>

                <!-- List Display -->
                <ul class="list-group" v-if="!loading">
                    <li v-for="agent in agents" :key="agent.id" class="list-group-item">
                        <div class="d-flex">
                            <div class="flex-grow-1 align-self-center my-1">
                                <p class="mb-0">
                                    <span class="align-middle">{{ agent.name }}</span>
                                </p>
                                <p class="mb-2 small">{{ agent.description }}</p>
                                <p class="mb-0 text-secondary small" v-if="agent.last_modified_by">
                                    Last modified by {{ agent.last_modified_by.email }} on
                                    {{ formatDateTime(agent.last_modified) }}
                                </p>
                                <div class="small mt-2" v-show="agent.unreviewed_interaction_count > 0">
                                    <span
                                        class="icon icon-glyphicons-basic-circle-alert text-danger"
                                        style="margin-right: 4px"
                                    ></span>
                                    <router-link :to="{ name: 'ChatAgentDetail', params: { id: agent.id }, query: { tab: 'review' } }"
                                        >Review {{ agent.unreviewed_interaction_count }} Missed Intents</router-link
                                    >
                                </div>
                            </div>
                            <div class="align-self-center">
                                <button @click="openEdit(agent)" class="btn btn-light btn-sm mr-1">
                                    <span class="icon icon-glyphicons-basic-square-edit"></span>
                                    Basic Info
                                </button>
                                <router-link
                                    :to="{ name: 'ChatAgentDetail', params: { id: agent.id } }"
                                    class="btn btn-light btn-sm"
                                >
                                    <span class="icon icon-glyphicons-basic-cogwheel mr-1"></span>
                                    <span>Configure</span>
                                </router-link>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <!-- Edit Modal -->
        <base-modal id="edit-modal" :loading="modalLoading" :centered="true">
            <template slot="title"> New Intent </template>
            <template>
                <div class="row">
                    <div class="col-12">
                        <base-form :fields="agentFormFields" v-model="selectedAgent" ref="editAgentForm"></base-form>
                    </div>
                </div>
            </template>
            <template slot="footer">
                <button class="btn btn-secondary" type="button" data-dismiss="modal">Close</button>
                <button @click="save()" class="btn btn-primary" type="button">Save</button>
            </template>
        </base-modal>
    </div>
</template>

<script>
import http from "@/axios.js"
import Utilities from "@/assets/js/utilities.js"
import BaseModal from "@/components/BaseModal"
import BaseForm from "@/components/BaseForm"

export default {
    name: "ChatAgents",
    components: {
        BaseModal,
        BaseForm,
    },
    data() {
        return {
            agents: [],
            selectedAgent: {},
            agentFormFields: [
                {
                    name: "Name",
                    key: "name",
                    subtext: "A name to identify this chat agent.",
                    placeholder: "Name",
                    maxlength: 50,
                    required: true,
                },
                {
                    name: "Description",
                    key: "description",
                    subtext: "A short description of this chat agent.",
                    type: "textarea",
                    rows: 2,
                    placeholder: "Description",
                    maxlength: 200,
                    required: false,
                },
            ],
            modalLoading: false,
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
    },
    methods: {
        async fetchData() {
            this.$store.dispatch("addLoad")
            await this.$store.dispatch("fetchAuth")
            let vm = this
            http.get("/api/chat-agents/", {
                params: {
                    organizationID: this.$store.getters.currentOrganization.id,
                },
            }).then(function (response) {
                vm.agents = response.data
                vm.$store.dispatch("removeLoad")
            })
        },
        openEdit(agent) {
            this.$refs.editAgentForm.resetValidate()
            this.selectedAgent = Object.assign({}, agent)
            $("#edit-modal").modal("show")
        },
        save() {
            if (!this.$refs.editAgentForm.validate()) {
                return
            }
            this.modalLoading = true
            let vm = this
            http.put(`/api/chat-agents/${this.selectedAgent.id}/`, this.selectedAgent)
                .then(function () {
                    vm.fetchData()
                    $("#edit-modal").modal("hide")
                    vm.$notify({
                        group: "main",
                        type: "success",
                        text: "Chat agent saved.",
                        data: {},
                    })
                })
                .finally(function () {
                    vm.modalLoading = false
                })
        },
        // Format a date object as a string.
        formatDateTime(dateObj) {
            return Utilities.formatDateTime(dateObj)
        },
    },
    created() {
        this.fetchData()
    },
}
</script>

<style>
</style>